import { render, staticRenderFns } from "./TackCoat.vue?vue&type=template&id=36e6c760"
import script from "./TackCoat.vue?vue&type=script&lang=js"
export * from "./TackCoat.vue?vue&type=script&lang=js"
import style0 from "./TackCoat.vue?vue&type=style&index=0&id=36e6c760&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports